import { ITimecardEmployee, ITimecardEquipment, ITimecard, ITimeTotals, IObjectAudit } from "../../../models"
import { ITimecardPriorPeriodData } from "../../data/timecard/TimecardPriorPeriodData";

export interface IObjectTimecardDocument {
    Id: string
    ObjectId: string
    EmployeeHierarchyId: string
    Employee: ITimecardEmployee
    Equipment: ITimecardEquipment
    AccountId: string
    StartDate: string
    EndDate: string
    StartDateUTC: string
    EndDateUTC: string
    MasterTimecard: ITimecard
    ComponentTimecards: ITimecard[]
    PayrollHierarchyId: string
    PayrollPayGroupId: string
    TotalPunchsets: number
    TotalMissingPunches: number
    TotalNotApproved: number
    TotalApproved: number
    TotalEmployeeNotApproved: number
    TotalEmployeeApproved: number
    TotalExported: number
    TotalPayrollExported: number
    TimeTotals: ITimeTotals
    PayGroupId: string
    PayweekStartDay: number
    TicksSinceChange: number
    ExcludeFromTimecardReview: boolean
    Deleted: boolean
    PriorPeriodAdjusted: boolean
    PriorPeriodData: ITimecardPriorPeriodData
    AllowModifications: boolean
    BlendedOvertimeRate: number
    PunchRuleNoOperationLogs: INoOperation[]
    PunchRuleProperties: IRuleProperty[]
    ApprovalValidationList: IApprovalValidation[]
}

export enum IApprovalValidationType {
    Error = 0,
    Warning = 1,
    Info = 2,
    System = 3
}

export interface IApprovalValidation
{
    ApprovalValidationType: IApprovalValidationType
    PreventApproval: boolean
    HideOnTimecard: boolean
    Name: string
    Details: string
    Read:boolean
    ReadBy:string
    Readon:Date
    ValidationDate:Date
    Id:string
}

export interface INoOperation
{
    PunchRuleId: string
    Title: string
    Description: string
    LogDateTime: string
}

export interface IRuleProperty
{
    DisplayName: string
    Value: string
    DateTime: string
    Enabled: boolean
    Scope: number
    ObjectAudit: IObjectAudit
}